import React from "react";
import { Button } from "../../Button";

export function Step({ children, onSkip, onNext, skipDisabled = false, nextDisabled = false, lastStep = false, skipLabel = "Skip", nextLabel = "Next" }) {
  return (
    <div className="step-container">
      {children}
      <footer>
        {/* <Button
          className="skip"
          secondary
          onClick={onSkip}
          disabled={skipDisabled}
        >
          {skipLabel}
        </Button> */}
        <Button
          primary={true}
          onClick={onNext}
          disabled={nextDisabled}
        >
          {lastStep ? "Done" : nextLabel}
        </Button>
      </footer>
    </div>
  );
}
